export default {
  baseURL: '/',
  timeout: 30000,
  key: 'A04@~1#!2019&qa.',
  staticURL:
    process.env.NODE_ENV == 'production'
      ? location.origin
      : 'http://136.a06bbs.com',
}
